module.exports = __webpack_public_path__ + "8d9fbd35dcfdc345e428f01702a7ac8d.png";